import { Popover } from "antd";
import styled from "styled-components";

import { Text } from "@/components/Typography";

import { TSeverity } from "../../Notifications.types";

export const Container = styled.div`
    position: relative;
    display: flex;
    column-gap: 4px;
    padding: 12px 16px 12px 24px;
    border-bottom: 1px solid ${props => props.theme.layouts.mainLayout.header.notifications.dividerColor};

    &:last-child {
        border-bottom: 0;
    }
`;

export const IconContainer = styled.div<{ $colorVariant: TSeverity }>`
    position: relative;
    display:flex;
    padding: 6px 10px 0 4px;
    color: ${({ theme, $colorVariant }) => theme.layouts.mainLayout.header.notifications[`${$colorVariant}IconColor`]};
`;

export const Point = styled.div<{ $colorVariant: TSeverity; $visible: boolean }>`
    position: relative;
    top: -2px;
    width: 4px;
    height: 4px;
    visibility: ${({ $visible }) => $visible ? "visible" : "hidden"};
    background-color: ${({ theme, $colorVariant }) => theme.layouts.mainLayout.header.notifications[`${$colorVariant}IconColor`]};
    border-radius: 50%
`;

export const ContentText = styled(Text)`
    padding-top: 6px;
    color: ${props => props.theme.layouts.mainLayout.header.notifications.contentColor};
    white-space: break-spaces;
`;

export const TimeText = styled(Text)`
    padding-bottom: 2px;
    color: ${props => props.theme.layouts.mainLayout.header.notifications.timeColor};
`;

export const OptionsPopover = styled(Popover)`
    position: relative;
    top: -5px;
    right: -5px;
    height: min-content;
    cursor: pointer;
`;
